import Vue from 'vue'
import Vuex from 'vuex'
import http from '../api/index'
import env from '../config/env'
import share from '../common/share'
import wxLogin from './wxLogin.js'
// import axios from 'axios'
Vue.use(Vuex)
const storeData = new Vuex.Store({
  state: {
    notFound: false,
    isPhoneX: false,
    balance: 0,
    videoMask: false,
    qywork: false, // 企业微信状态 true就是企业微信环境
    isShare: false, // 直销员把单页分享出去，然后从哪个分享出去的页面进入，就是 isShared 是 true
    isShowAuthModal: false,
    refreshAuth: false,
    isSalor: false,
    mask: false,
    // 新版门店
    shops: [],
    profile: {
      oAuthId: '',
    },
    detail: {},
    editor: {},
    location: {
      area: [],
      activeId: [],
      items: [],
    },
    coupons: [],
    vcard: {
      avatar: '',
      name: '',
      position: '',
      company: '',
      mobile: '',
      email: '',
      address: '',
      qrCode: '',
    },
    vcardImg: '',
    // 红包设置
    fission: {
      allowStaffParticipate: 'Y',
      maximumAmount: '',
      minimumAmount: '',
      upperLimitAmount: '',
    },
    // 门店
    stores: [],
    // 秒杀券商品规则
    flashSales: {},
    // 秒杀条件
    flashCondition: {
      conditionStatus: '',
      conditionList: [],
      num: {
        VISIT: 0,
        ENTER: 0,
        AMBASSADOR: 0,
      },
    },
    // 卡包数据
    cardBag: [],
    // 关联内容
    material: [],
    // 单个活动任务详情
    taskActivityDetail: {},
    ruleDes:'', // 卡包规则说明
    canSaveCard: true, // 是否保存卡包创建信息
    // wxToken:'', // 微信token
    wxCode:'', // 微信code
  },
  getters: {
    getSelectCardBag: (state) => {
      console.log(
        'getSelectCardBag',
        state.cardBag.filter((item) => item.editType !== 'DELETE')
      )
      return state.cardBag.filter((item) => item.editType !== 'DELETE')
    },
    isWeiXin:()=>{
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger' ) {
        if((ua.match(/wxwork/i) == 'wxwork')){
          return false; // 是微信端
        }else{
          return true;
        }
      } else {
          return false;
      }
    }
  },
  modules:{
    wxLogin
  },
  mutations: {
    updateMaterial(state, status) {
      state.material = status
    },
    // updateWxToken(state, status) {
    //   state.wxToken = status
    // },
    updateWxCode(state, status) {
      state.wxCode = status
    },
    updateTaskActivityDetail(state, status) {
      state.taskActivityDetail = status
    },
    updateCardBug(state, status) {
      state.cardBag = status
    },
    updateRuleDes(state, status) {
      state.ruleDes = status
    },
    updateCanSaveCard(state, status) {
      state.canSaveCard = status
    },
    updateBalance(state, status) {
      state.balance = status
    },
    adjustX(state, status) {
      state.isPhoneX = status
    },
    saveCondition(state, status) {
      state.flashCondition = status
    },
    updateFlashSales(state, status) {
      state.flashSales = status
    },
    updateNet(state, status) {
      state.notFound = status
    },
    updateShops(state, status) {
      state.shops = status
    },
    updateVcardImg(state, status) {
      state.vcardImg = status
    },
    updateMask(state, status) {
      state.mask = status
    },
    updateSalor(state, status) {
      state.isSalor = status
    },
    updateVcard(state, status) {
      state.vcard = status
    },
    updateStores(state, status) {
      state.stores = status
    },
    updateLocation(state, status) {
      state.location = status
    },
    updateFission(state, status) {
      state.fission = status
    },
    updateCoupon(state, status) {
      state.coupons = status
    },
    updateRollCoupon(state, status) {
      state.coupons = status
    },
    setDetail(state, status) {
      state.detail = status
    },
    changeEnvironment(state, status) {
      state.qywork = status
    },
    updateShare(state, status) {
      state.isShare = status
    },
    updateVideoMask(state, status) {
      state.videoMask = status
    },
    updateProfile(state, status) {
      state.profile = status
    },
    updateDetail(state, status) {
      state.editor = status
    },
    changeAuthModal(state, status) {
      state.isShowAuthModal = status
    },
    refreshAuthModal(state, status) {
      state.refreshAuth = status
    },
  },
  actions: {
    requestProfile({ commit }) {
      // const url = store.state.isCompanyChat
      //   ? 'esenaccount/openapi/sns/account?type=WXCP'
      //   : 'esenaccount/openapi/sns/account?type=WECHAT'
      const url = 'aocampaignsales/openapi/sales/staff/info'
      console.log('请求个人信息')
      commit('updateMask', true)
      commit('refreshAuthModal', false)
      return new Promise((resolve) => {
        http
          .get(url)
          .then((res) => {
            commit('updateMask', false)
            res.data.avatarUrl = res.data.avatarUrl
              ? res.data.avatarUrl.replace('http:', 'https:')
              : ''
            commit('updateProfile', res.data)
            const wxProfile = localStorage.getItem('userInfo')
            // const wxProfile = uni.getStorageSync('userInfo')
            if (!res.data.name && wxProfile) {
              res.data.name = wxProfile.nickName
              res.data.imageUrl = wxProfile.avatarUrl.replace('http:', 'https:')
            }
            console.log('获取基本信息的数据', res)
            window.wx.uma.setOpenid(localStorage.getItem('register').openId)
            // window.wx.uma.setOpenid(uni.getStorageSync('register').openId)
            // uni.setStorageSync('profile', res.data)
            localStorage.setItem('profile', res.data)
            if (res.data.userId) {
              // http.get(api.openIdUrl).then(async resData => {
              //   if (resData.statusCode === 200) {
              //     console.log('个人信息获取2', resData.data)
              //     uni.setStorageSync('userOpenId', resData.data.openId)
              //   }
              // })
            }
            resolve(true)
          })
          .catch(async () => {
            // console.log('获取信息失败', e)
            // const token = uni.getStorageSync('register')
            // console.log('token', token)
            // commit('changeAuthModal', false)
            // await share.sleep(10)
            // if (!token) {
            //   commit('changeAuthModal', true)
            //   if (store.state.isShowAuthModal) {
            //     commit('refreshAuthModal', true)
            //   }
            // }
            resolve(false)
            // commit('changeShowBind', false)
          })
      })
    },
    async login({ dispatch, commit }) {
      if (await dispatch('requestProfile')) {
        commit('changeAuthModal', false)
        return true
      } else {
        return false
      }
    },
    requestVcard(
      { commit },
      { type = 'normal', activityId, contentId, contentName }
    ) {
      return new Promise((s) => {
        // if (store.state.vcard.mobile) {
        //   return s()
        // }
        let url =
          'aocampaignsales/openapi/sales/callingCard/info' +
          `?agentId=${env.agentId}`
        if (type && type === 'activity') {
          url = `aocampaignsales/openapi/sales/callingCard/activity-info/${env.agentId}/${activityId}`
        }
        if (type && type === 'material') {
          url = `aocampaignsales/openapi/sales/callingCard/content-info/${env.agentId}/${contentId}?contentName=${contentName}`
        }
        if(type && type === 'equitys'){
          url = `aocampaignsales/openapi/sales/callingCard/info?agentId=${env.agentId}`
        }
        console.log(env.agentId)
        http.get(url).then((res) => {
          const vcard = {
            avatar: '',
            name: '',
            position: '',
            company: '',
            mobile: '',
            email: '',
            address: '',
            qrCode: '',
            sysUserId: '',
          }
          const keys = Object.keys(vcard)
          keys.forEach((item) => {
            vcard[item] = res.data[item] ? res.data[item] : ''
          })
          if (vcard.avatar) {
            vcard.avatar = vcard.avatar.replace('http:', 'https:')
            // vcard.avatar = 'http://aosnext-test-img.hotwater.com.cn/images/20200426/758f33ed5a7b4735807eca18b17c7396.png'
            // vcard.avatar = null
          }
          if (vcard.qrCode) {
            vcard.qrCode = vcard.qrCode.replace('http:', 'https:')
            // vcard.avatar = 'http://aosnext-test-img.hotwater.com.cn/images/20200426/758f33ed5a7b4735807eca18b17c7396.png'
            // vcard.avatar = null
          }
          console.log(vcard)
          commit('updateVcard', vcard)
          s(vcard)
        }).catch(res=>{
          s(res)
        })
      })
    },
    requestBalance({ commit }) {
      return new Promise((s) => {
        http
          .post('aocampaignsales/openapi/sales/activity/account/info')
          .then((res) => {
            commit('updateBalance', res.data.balance)
            s(res.data.balance)
          })
      })
    },
    // from 用来判断调ao的接口还是特赞的
    requestMaterialList(
      { commit },
      { from = 'tezan', categoryId, keyword, page, columnId }
    ) {
      return new Promise((s) => {
        console.log('commit',commit)
        console.log(from)
        if (from === 'ao') {
          http.post(env.materialUrl + 'cfsite/material/list',
          {
            header: {
              'Content-Type': 'application/x-www-form-urlencoded',
              // 'Authorization': `Bearer 17ad2342-d11f-4350-8771-ecf73c4b6a8d`,
            },
            data: {
              categoryId,
              columnId,
              keyword,
              page: page,
            },
          }).then((res) => {
            s(res.data)
          })
          // const [e, res] = await uni.request({
          //   url: env.materialUrl + 'cfsite/material/list',
          //   method: 'POST',
          //   header: {
          //     'Content-Type': 'application/x-www-form-urlencoded',
          //   },
          //   data: {
          //     categoryId,
          //     columnId,
          //     keyword,
          //     page: page,
          //   },
          // })
          // s(res.data)
        } else {
          let dataObject={}
          if(categoryId){
            dataObject.categoryId=categoryId
          }
          if(columnId){
            dataObject.columnId=columnId
          }
          if(keyword){
            dataObject.keyword=keyword
          }
          dataObject.page=page
          const data =dataObject
          http.get(
            `aocampaignsales/openapi/tezign/getMaterialListWithNewType${share.qsUrl(data)}`,
          ).then((res) => {
            if (res.data.code !== '0') {
              this.$Toast(res.data.message)
            }
            s(res.data.result)
          })
        }
      })
    },
    // from 用来判断调ao的接口还是特赞的 personId 直销员id
    requsetMaterialDetail({ commit }, { from = 'ao', materialId, personId }) {
      return new Promise((s) => {
        console.log('commit',commit)
        console.log(from)
        if (from === 'ao') {
          http.post(env.materialUrl + 'cfsite/material/detail',{
            header: {
              'Content-Type': 'application/x-www-form-urlencoded',
              // 'Authorization': `Bearer 17ad2342-d11f-4350-8771-ecf73c4b6a8d`,
            },
            data: {
              appid: env.appId,
              personId,
              personType: 1,
              materialId,
            },
          }).then((res) => {
            s(res.data)
          })
        } else {
          const data = {
            appid: env.appId,
            personId,
            personType: 1,
            materialId,
          }
          http.get(
            `aocampaignsales/openapi/tezign/getMaterialDetail${share.qsUrl(
              data
            )}` , {
            }
          ).then((res) => {
            if (res.data.code !== '0') {
              this.$Toast(res.data.message)
            }
            s(res.data.result)
          })
        }
      })
    }
  },
})

export default storeData
